import React from 'react'


export const upperTrim = text => text.replace(/\s/g, '').toUpperCase()

export const splitAndSpan = (text, bold = false) => text.toUpperCase().split('').map((l, i) => {
    return bold ? <b key={i}>{l}</b> : <span key={i}>{l}</span>
})

export const titleCase = text => text.split(" ").map(([i, ...rest]) => [i.toUpperCase(), ...rest].join("")).join(" ")